export default {
    methods: {
        downloadBase64(url, name) {
            fetch(url)
                .then(res => res.blob())
                .then(binary => {
                    const url = window.URL.createObjectURL(binary)
                    const a = document.createElement('a')
                    a.style.display = 'none'
                    a.href = url
                    a.download = name
                    document.body.appendChild(a)
                    a.click()
                    window.URL.revokeObjectURL(url)
                })
        }
    }
}
